
import { mapGetters } from "vuex";
import { addScripts, extractDataFromScriptTags } from "@/utils";

export default {
  name: "RichTextBlock",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      backgroundTypes: {
        default: 1,
        color: 2,
        image: 3,
        custom: 4,
      },
    };
  },
  computed: {
    ...mapGetters({
      appBreakpoints: "general/getAppBreakpoints",
    }),
    backgroundStyle() {
      switch (this.data.background_type) {
        case this.backgroundTypes.color: {
          return {
            backgroundColor:
              this.data.color.hexa || this.data.color || "transparent",
          };
        }
        case this.backgroundTypes.custom: {
          return {
            background: this.data.custom_background,
          };
        }
        default: {
          return {};
        }
      }
    },
    formattedContent() {
      // Define a regular expression to match script tags with a function
      const scriptTagRegex = /<script\b[^>]*>[\s\S]*?function[^>]*<\/script>/gi;
      // Use the replace method to remove script tags with functions
      const modifiedHtmlString = this.data.content.replace(
        scriptTagRegex,
        ""
      );
      return modifiedHtmlString;
    },
  },
  mounted() {
    const scripts = extractDataFromScriptTags(this.data.content);

    scripts.forEach(script => {
      addScripts(script, this.$refs.target, "end");
    });
  },
};
